import { _ as e, A as t, $ as n, e as s, f as a, h as i, u as r, g as l, U as u, a0 as o, m as d, a as c, M as h, r as p, s as m, K as f, X as g, a1 as y, a2 as _, a3 as v, Q as I, a4 as M, a5 as T, a6 as S, a7 as A, b, c as U, t as E, S as w, a8 as F, V as q, a9 as D, aa as N, ab as P, ac as C, W as R, x as L, y as O, ad as k, ae as z, i as x, af as Q, ag as G, ah as B, w as j, ai as H, aj as W, ak as K, n as V, al as X, B as $, am as J, an as Y } from "./__bundle-75942676.js";
var Z,
  ee = function (a) {
    function i(e) {
      var i = a.call(this) || this;
      if (i.method = t.POST, i.path = "".concat(n), i.params = s({
        file: e.file,
        channel_url: e.channelUrl
      }), e.thumbnailSizes) for (var r = 0; r < e.thumbnailSizes.length; r++) {
        var l = e.thumbnailSizes[r],
          u = l.maxWidth,
          o = l.maxHeight;
        i.params["thumbnail".concat(r + 1)] = "".concat(u, ",").concat(o);
      }
      return i.requestId = e.requestId, i;
    }
    return e(i, a), i;
  }(a),
  te = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r = this;
      return (r = t.call(this, e, n) || this).url = n.url, r.fileSize = null !== (s = n.file_size) && void 0 !== s ? s : 0, r.thumbnailSizes = null !== (a = n.thumbnails) && void 0 !== a ? a : [], r.requireAuth = null !== (i = n.require_auth) && void 0 !== i && i, r;
    }
    return e(n, t), n;
  }(i),
  ne = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r = this;
      return (r = t.call(this, e) || this).replyCount = 0, r.lastRepliedAt = 0, r.updatedAt = 0, r.replyCount = null !== (s = n.reply_count) && void 0 !== s ? s : 0, r.mostRepliedUsers = n.most_replies && d("object", n.most_replies) ? n.most_replies.map(function (e) {
        return new u(r._iid, e);
      }) : [], r.lastRepliedAt = null !== (a = n.last_replied_at) && void 0 !== a ? a : 0, r.updatedAt = null !== (i = n.updated_at) && void 0 !== i ? i : 0, r;
    }
    return e(n, t), n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        reply_count: e.replyCount,
        most_replies: Array.isArray(e.mostRepliedUsers) ? e.mostRepliedUsers.map(function (e) {
          return u.payloadify(e);
        }) : [],
        last_replied_at: e.lastRepliedAt,
        updated_at: e.updatedAt
      })));
    }, n;
  }(o);
!function (e) {
  e.ADD = "add", e.DELETE = "delete";
}(Z || (Z = {}));
var se,
  ae,
  ie = function ie(e) {
    this.messageId = 0, this.operation = null, this.updatedAt = 0;
    var t = c("string", e.msg_id) ? parseInt(e.msg_id) : e.msg_id,
      n = e.user_id,
      s = e.operation ? e.operation.toLowerCase() : null,
      a = e.reaction,
      i = e.updated_at;
    t && c("string", n) && c("string", s) && h(Z, s) && c("string", a) && a && c("number", i) && (this.messageId = t, this.userId = n, this.key = a, this.operation = s, this.updatedAt = i);
  },
  re = function () {
    function e(e) {
      var t,
        n,
        s,
        a = e.key,
        i = null !== (s = p([], m(e.user_ids), !1)) && void 0 !== s ? s : [],
        r = e.updated_at;
      c("string", a) && a && d("string", i) && i.length > 0 && c("number", r) && (this.key = a, this.userIds = i, this.updatedAt = r);
      var l = {};
      try {
        for (var u = f(this.userIds), o = u.next(); !o.done; o = u.next()) {
          l[o.value] = this.updatedAt;
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          o && !o.done && (n = u.return) && n.call(u);
        } finally {
          if (t) throw t.error;
        }
      }
      this._version = l;
    }
    return Object.defineProperty(e.prototype, "isEmpty", {
      get: function get() {
        return 0 === this.userIds.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.payloadify = function (e) {
      return s(r({
        key: e.key,
        user_ids: e.userIds,
        updated_at: e.updatedAt
      }));
    }, e.prototype.applyEvent = function (e) {
      if (e.key === this.key && this.updatedAt <= e.updatedAt) {
        if (!this._version[e.userId] || this._version[e.userId] <= e.updatedAt) {
          var t = this.userIds.indexOf(e.userId);
          switch (e.operation) {
            case Z.ADD:
              t < 0 && this.userIds.push(e.userId);
              break;
            case Z.DELETE:
              t >= 0 && this.userIds.splice(t, 1);
          }
          this._version[e.userId] = e.updatedAt;
        }
        this.updatedAt = Math.max(this.updatedAt, e.updatedAt);
      }
    }, e;
  }(),
  le = function () {
    function e(e) {
      this.key = e.key, this.value = d("string", e.value) ? p([], m(e.value), !1) : [];
    }
    return e.payloadify = function (e) {
      var t;
      return s(r({
        key: e.key,
        value: null !== (t = e.value) && void 0 !== t ? t : []
      }));
    }, e;
  }(),
  ue = function () {
    function e(e) {
      this.secureUrl = null, this.type = null, this.width = 0, this.height = 0, this.alt = null, this.url = e.url, e.secure_url && (this.secureUrl = e.secure_url), e.type && (this.type = e.type), e.width && (this.width = e.width), e.height && (this.height = e.height), e.alt && (this.alt = e.alt);
    }
    return e.payloadify = function (e) {
      var t, n;
      return s(r({
        url: e.url,
        secure_url: e.secureUrl,
        type: e.type,
        width: null !== (t = e.width) && void 0 !== t ? t : 0,
        height: null !== (n = e.height) && void 0 !== n ? n : 0,
        alt: e.alt
      }));
    }, e;
  }(),
  oe = function () {
    function e(e) {
      this.title = null, this.url = null, this.description = null, this.defaultImage = null, e["og:title"] && (this.title = e["og:title"]), e["og:url"] && (this.url = e["og:url"]), e["og:description"] && (this.description = e["og:description"]), e["og:image"] && (this.defaultImage = new ue(e["og:image"]));
    }
    return e.payloadify = function (e) {
      return s(r({
        "og:title": e.title,
        "og:url": e.url,
        "og:description": e.description,
        "og:image": e.defaultImage ? ue.payloadify(e.defaultImage) : null
      }));
    }, e;
  }(),
  de = function () {
    function e(e) {
      var t, n;
      this.volume = 0, this.name = null !== (t = e.name) && void 0 !== t ? t : "default", this.volume = null !== (n = e.volume) && void 0 !== n ? n : 1;
    }
    return e.prototype.serialize = function () {
      return {
        name: this.name,
        volume: this.volume
      };
    }, e.payloadify = function (e) {
      return s(r({
        name: e.name,
        volume: e.volume
      }));
    }, e;
  }(),
  ce = function (t) {
    function n(e, n) {
      var s,
        a = this;
      return (a = t.call(this, e, n) || this).isBlockedByMe = !1, a.role = h(g, n.role) ? n.role : g.NONE, a.isBlockedByMe = null !== (s = n.is_blocked_by_me) && void 0 !== s && s, a;
    }
    return e(n, t), n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        role: e.role,
        is_blocked_by_me: e.isBlockedByMe
      })));
    }, n;
  }(u);
!function (e) {
  e.PENDING = "pending", e.SENT = "sent", e.FAILED = "failed", e.CANCELED = "canceled";
}(se || (se = {})), function (e) {
  e.PENDING = "pending", e.IN_QUEUE = "in_queue", e.SENT = "sent", e.FAILED = "failed", e.CANCELED = "canceled", e.REMOVED = "removed";
}(ae || (ae = {}));
var he = function he(e) {
    switch (e) {
      case _.BASE:
        return "";
      case _.USER:
        return "MESG";
      case _.FILE:
        return "FILE";
      case _.ADMIN:
        return "ADMM";
    }
  },
  pe = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r,
        l,
        o,
        d,
        c,
        p,
        m,
        f,
        g,
        y,
        v,
        T,
        S,
        A = this;
      (A = t.call(this, e) || this).channelType = I.BASE, A.parentMessage = null, A.silent = !1, A.isOperatorMessage = !1, A.messageType = _.BASE, A.mentionType = null, A.threadInfo = null, A.reactions = [], A.metaArrays = [], A.appleCriticalAlertOptions = null, A.createdAt = 0, A.updatedAt = 0, A.scheduledInfo = null, A.extendedMessage = {}, A._isContinuousMessages = !1, A._scheduledStatus = null, A.messageId = null !== (a = null !== (s = n.msg_id) && void 0 !== s ? s : n.message_id) && void 0 !== a ? a : 0, A.channelUrl = n.channel_url, A.channelType = h(I, n.channel_type) ? n.channel_type : I.GROUP, n.channel && (n.channel.channel_url && (A.channelUrl = n.channel.channel_url), n.channel.channel_type && (A.channelType = n.channel.channel_type)), A.parentMessageId = null !== (i = "string" == typeof n.parent_message_id ? parseInt(n.parent_message_id) : n.parent_message_id) && void 0 !== i ? i : 0, A.data = null !== (r = n.data) && void 0 !== r ? r : "", A.customType = null !== (l = n.custom_type) && void 0 !== l ? l : "", A.mentionType = h(M, n.mention_type) ? n.mention_type : null, A.mentionedUsers = n.mentioned_users ? n.mentioned_users.map(function (e) {
        return new u(A._iid, e);
      }) : null, A.mentionedUserIds = null !== (o = n.mentioned_user_ids) && void 0 !== o ? o : null, A.mentionedUsers && !A.mentionedUserIds && (A.mentionedUserIds = A.mentionedUsers.map(function (e) {
        return e.userId;
      })), A.mentionedMessageTemplate = null !== (d = n.mentioned_message_template) && void 0 !== d ? d : "", A.threadInfo = n.thread_info ? new ne(A._iid, n.thread_info) : null, A.reactions = n.reactions ? n.reactions.map(function (e) {
        return new re(e);
      }) : [];
      var b = null !== (c = n.metaarray) && void 0 !== c ? c : {},
        U = null !== (p = n.metaarray_key_order) && void 0 !== p ? p : Object.keys(b).sort(function (e, t) {
          return e.localeCompare(t);
        });
      A.metaArrays = [];
      for (var E = 0; E < U.length; E++) {
        var w = U[E];
        A.metaArrays.push(new le({
          key: w,
          value: b[w] || []
        }));
      }
      return n.sorted_metaarray && (A.metaArrays = n.sorted_metaarray.map(function (e) {
        return new le(e);
      })), A.ogMetaData = n.og_tag ? new oe(n.og_tag) : null, A.silent = null !== (m = n.silent) && void 0 !== m && m, A.isOperatorMessage = null !== (f = n.is_op_msg) && void 0 !== f && f, A.appleCriticalAlertOptions = n.apple_critical_alert_options ? new de(n.apple_critical_alert_options) : null, A.createdAt = null !== (y = null !== (g = n.created_at) && void 0 !== g ? g : n.ts) && void 0 !== y ? y : 0, A.updatedAt = null !== (v = n.updated_at) && void 0 !== v ? v : 0, "number" == typeof n.scheduled_message_id && "number" == typeof n.scheduled_at && n.scheduled_status && (A.scheduledInfo = {
        scheduledMessageId: n.scheduled_message_id,
        scheduledAt: n.scheduled_at
      }, A._scheduledStatus = n.scheduled_status), A.extendedMessage = null !== (T = n.extended_message) && void 0 !== T ? T : {}, A._isContinuousMessages = null !== (S = n.is_continuous_messages) && void 0 !== S && S, A;
    }
    return e(n, t), n.payloadify = function (e) {
      var n, a, i, o;
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        channel_url: e.channelUrl,
        channel_type: e.channelType,
        message_id: e.messageId,
        type: he(e.messageType),
        parent_message_id: e.parentMessageId,
        data: e.data,
        custom_type: e.customType,
        mention_type: e.mentionType,
        mentioned_user_ids: e.mentionedUserIds,
        mentioned_users: null === (n = e.mentionedUsers) || void 0 === n ? void 0 : n.map(function (e) {
          return u.payloadify(e);
        }),
        mentioned_message_template: e.mentionedMessageTemplate,
        thread_info: e.threadInfo ? ne.payloadify(e.threadInfo) : null,
        reactions: e.reactions.map(function (e) {
          return re.payloadify(e);
        }),
        sorted_metaarray: null === (a = e.metaArrays) || void 0 === a ? void 0 : a.map(function (e) {
          return le.payloadify(e);
        }),
        og_tag: e.ogMetaData ? oe.payloadify(e.ogMetaData) : null,
        silent: e.silent,
        is_op_msg: e.isOperatorMessage,
        apple_critical_alert_options: e.appleCriticalAlertOptions ? de.payloadify(e.appleCriticalAlertOptions) : null,
        created_at: e.createdAt,
        updated_at: e.updatedAt,
        scheduled_message_id: null === (i = e.scheduledInfo) || void 0 === i ? void 0 : i.scheduledMessageId,
        scheduled_at: null === (o = e.scheduledInfo) || void 0 === o ? void 0 : o.scheduledAt,
        scheduled_status: e._scheduledStatus,
        extended_message: e.extendedMessage
      })));
    }, n._getParentMessageInfoPayload = function (e) {
      return s(r({
        type: e.messageType,
        ts: e.createdAt,
        user: e.sender ? ce.payloadify(e.sender) : null,
        message: e.message,
        file: {
          url: e.plainUrl,
          name: e.name,
          type: e.type,
          require_auth: e.requireAuth
        }
      }));
    }, n.prototype.isIdentical = function (e) {
      return this.messageId === e.messageId;
    }, n.prototype.isEqual = function (e) {
      return y(this, e);
    }, n.prototype.isUserMessage = function () {
      return this.messageType === _.USER;
    }, n.prototype.isFileMessage = function () {
      return this.messageType === _.FILE && !Object.prototype.hasOwnProperty.call(this, "fileInfoList");
    }, n.prototype.isMultipleFilesMessage = function () {
      return this.messageType === _.FILE && Object.prototype.hasOwnProperty.call(this, "fileInfoList");
    }, n.prototype.isAdminMessage = function () {
      return this.messageType === _.ADMIN;
    }, n.prototype.serialize = function () {
      return v(this);
    }, n.prototype.getMetaArraysByKeys = function (e) {
      return this.metaArrays.filter(function (t) {
        return e.includes(t.key);
      });
    }, n.prototype.applyThreadInfoUpdateEvent = function (e) {
      return this.messageId === e.targetMessageId && (this.threadInfo = e.threadInfo), !1;
    }, n.prototype.applyReactionEvent = function (e) {
      if (this.messageId === e.messageId) {
        for (var t = !1, n = 0; n < this.reactions.length; n++) if (this.reactions[n].key === e.key) {
          this.reactions[n].applyEvent(e), this.reactions[n].isEmpty && this.reactions.splice(n, 1), t = !0;
          break;
        }
        t || "add" !== e.operation || this.reactions.push(new re(re.payloadify({
          key: e.key,
          userIds: [e.userId],
          updatedAt: e.updatedAt
        })));
      }
    }, n.prototype.applyParentMessage = function (e) {
      if (!this.parentMessage) return this.parentMessage = e, !0;
      if (this.parentMessageId === e.messageId) {
        var t = this.parentMessage.updatedAt;
        if (e.updatedAt >= t) return this.parentMessage = e, !0;
      }
      return !1;
    }, n;
  }(o),
  me = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r,
        l = this;
      if ((l = t.call(this, e, n) || this).reqId = "", l.replyToChannel = !1, l.errorCode = 0, l.sender = n.user ? new ce(l._iid, n.user) : n.sender_id, l.reqId = null !== (a = null !== (s = n.req_id) && void 0 !== s ? s : n.request_id) && void 0 !== a ? a : "", l.replyToChannel = null !== (i = n.is_reply_to_channel) && void 0 !== i && i, n.request_state && h(T, n.request_state) && (l.sendingStatus = n.request_state), !l.sendingStatus) if (l.messageId > 0) l.sendingStatus = T.SUCCEEDED;else if (l.scheduledInfo) switch (n.scheduled_status && (l._scheduledStatus = n.scheduled_status), n.scheduled_status) {
        case ae.SENT:
        case ae.IN_QUEUE:
          l.sendingStatus = T.SUCCEEDED;
          break;
        case ae.PENDING:
          l.sendingStatus = T.SCHEDULED;
          break;
        case ae.FAILED:
        case ae.REMOVED:
          l.sendingStatus = T.FAILED;
          break;
        case ae.CANCELED:
          l.sendingStatus = T.CANCELED;
      } else l.sendingStatus = T.PENDING;
      return l.errorCode = null !== (r = n.error_code) && void 0 !== r ? r : 0, l;
    }
    return e(n, t), n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        user: ce.payloadify(e.sender),
        req_id: e.reqId,
        is_reply_to_channel: e.replyToChannel,
        request_state: e.sendingStatus,
        error_code: e.errorCode
      })));
    }, Object.defineProperty(n.prototype, "isResendable", {
      get: function get() {
        return this.sendingStatus === T.FAILED && S(this.errorCode);
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.isIdentical = function (e) {
      return this.messageId > 0 && e.messageId > 0 ? this.messageId === e.messageId : this.reqId === e.reqId;
    }, n;
  }(pe),
  fe = function () {
    function e(e) {
      var t, n;
      this.width = 0, this.height = 0, this.realWidth = 0, this.realHeight = 0, this.url = e.url, this.width = e.width, this.height = e.height, this.realWidth = null !== (t = e.real_width) && void 0 !== t ? t : e.width, this.realHeight = null !== (n = e.real_height) && void 0 !== n ? n : e.height;
    }
    return e.payloadify = function (e) {
      return s(r({
        url: "",
        width: e.maxWidth,
        height: e.maxHeight,
        real_width: 0,
        real_height: 0
      }));
    }, Object.defineProperty(e.prototype, "plainUrl", {
      get: function get() {
        return this.url.split("?auth=")[0];
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(),
  ge = {
    prevResultSize: 0,
    nextResultSize: 0,
    isInclusive: !1,
    reverse: !1,
    messageTypeFilter: A.ALL,
    customTypesFilter: void 0,
    senderUserIdsFilter: void 0,
    includeReactions: !1,
    includeMetaArray: !1,
    includeParentMessageInfo: !1
  },
  ye = function ye(e) {
    return c("number", e.prevResultSize) && c("number", e.nextResultSize) && c("boolean", e.isInclusive) && c("boolean", e.reverse) && c("string", e.messageTypeFilter) && h(A, e.messageTypeFilter) && d("string", e.customTypesFilter, !0) && d("string", e.senderUserIdsFilter, !0) && c("boolean", e.includeMetaArray) && c("boolean", e.includeReactions) && c("boolean", e.includeParentMessageInfo);
  },
  _e = function (t) {
    function n(e, n) {
      var a,
        i,
        u,
        o,
        d = this;
      if ((d = t.call(this, e, n) || this).translations = {}, d.message = null !== (a = n.message) && void 0 !== a ? a : "", d.messageType = _.ADMIN, d.translations = null !== (i = n.translations) && void 0 !== i ? i : {}, n.parent_message_info) {
        var c = n.parent_message_info;
        d.parentMessage = Ae(e, s(r(l(l({}, c), {
          message_id: d.parentMessageId,
          channel_url: d.channelUrl,
          channel_type: d.channelType,
          file: c.file,
          url: null === (u = c.file) || void 0 === u ? void 0 : u.url,
          require_auth: null === (o = c.file) || void 0 === o ? void 0 : o.require_auth
        }))));
      }
      return d;
    }
    return e(n, t), n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        message: e.message,
        translations: e.translations,
        parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null
      })));
    }, n.prototype.getThreadedMessagesByTimestamp = function (e, t) {
      return b(this, void 0, void 0, function () {
        var n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return n = l(l({}, ge), t), E(this.messageId > 0 && c("number", e) && ye(n)).throw(w.invalidParameters), [4, Ke.of(this._iid).getThreadedMessagesByTimestamp(this, e, n)];
            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, n;
  }(pe),
  ve = function () {
    function e(e) {
      var t, n;
      this.detail = {}, this.type = null !== (t = e.type) && void 0 !== t ? t : "", this.vendor = null !== (n = e.vendor) && void 0 !== n ? n : "", e.detail && c("object", e.detail) && !Array.isArray(e.detail) && (this.detail = e.detail);
    }
    return e.payloadify = function (e) {
      return s(r({
        type: e.type,
        vendor: e.vendor,
        detail: e.detail
      }));
    }, e;
  }(),
  Ie = function (t) {
    function n(e, n) {
      var a,
        i,
        u,
        o,
        d,
        c,
        h,
        p = this;
      if ((p = t.call(this, e, n) || this).message = "", p.messageParams = null, p.translations = {}, p.translationTargetLanguages = [], p.messageSurvivalSeconds = -1, p.plugins = [], p._poll = null, p.message = n.message, p.messageType = _.USER, p.translations = null !== (u = n.translations) && void 0 !== u ? u : {}, p.translationTargetLanguages = null !== (o = n.target_langs) && void 0 !== o ? o : [], 0 === Object.keys(p.translations).length && p.translationTargetLanguages.length > 0) try {
        for (var m = f(p.translationTargetLanguages), g = m.next(); !g.done; g = m.next()) {
          var y = g.value;
          p.translations[y] = "";
        }
      } catch (e) {
        a = {
          error: e
        };
      } finally {
        try {
          g && !g.done && (i = m.return) && i.call(m);
        } finally {
          if (a) throw a.error;
        }
      }
      if (p.messageSurvivalSeconds = null !== (d = n.message_survival_seconds) && void 0 !== d ? d : -1, p.plugins = n.plugins ? n.plugins.map(function (e) {
        return new ve(e);
      }) : [], p._poll = n.poll ? new F(p._iid, n.poll) : null, n.parent_message_info) {
        var v = n.parent_message_info;
        p.parentMessage = Ae(e, s(r(l(l({}, v), {
          created_at: v.ts,
          message_id: p.parentMessageId,
          channel_url: p.channelUrl,
          channel_type: p.channelType,
          file: v.file,
          url: null === (c = v.file) || void 0 === c ? void 0 : c.url,
          require_auth: null === (h = v.file) || void 0 === h ? void 0 : h.require_auth
        }))));
      }
      return p;
    }
    return e(n, t), n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        message: e.message,
        translations: e.translations,
        message_survival_seconds: e.messageSurvivalSeconds,
        plugins: e.plugins.map(function (e) {
          return ve.payloadify(e);
        }),
        poll: e._poll ? F.payloadify(e._poll) : null,
        parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null
      })));
    }, n.prototype.getThreadedMessagesByTimestamp = function (e, t) {
      return b(this, void 0, void 0, function () {
        var n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return n = l(l({}, ge), t), E(this.messageId > 0 && c("number", e) && ye(n)).throw(w.invalidParameters), [4, Ke.of(this._iid).getThreadedMessagesByTimestamp(this, e, n)];
            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, n.prototype.applyPoll = function (e) {
      return !(this._poll && this._poll.id === e.id && this._poll.updatedAt > e.updatedAt) && (this._poll = e, !0);
    }, Object.defineProperty(n.prototype, "poll", {
      get: function get() {
        return this._poll;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(me),
  Me = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r,
        u,
        o = this;
      (o = t.call(this, e) || this).plainUrl = "", o.fileName = null, o.mimeType = null, o.fileSize = 0, o.thumbnails = [], o._requireAuth = !1, o.plainUrl = null !== (s = n.url) && void 0 !== s ? s : "", o.fileName = null !== (a = n.file_name) && void 0 !== a ? a : null, o.mimeType = null !== (i = n.file_type) && void 0 !== i ? i : null, o.fileSize = null !== (r = n.file_size) && void 0 !== r ? r : 0, o._requireAuth = null !== (u = n.require_auth) && void 0 !== u && u;
      var d = q.of(o._iid).sessionManager;
      return o.thumbnails = n.thumbnails ? n.thumbnails.map(function (e) {
        return new fe(l(l({}, e), {
          url: "".concat(e.url.split("?auth=")[0]).concat(o._requireAuth ? "?auth=".concat(d.ekey) : "")
        }));
      }) : [], o;
    }
    return e(n, t), n.payloadify = function (e) {
      var t;
      return s(r({
        url: e.plainUrl,
        file_name: e.fileName,
        file_type: e.mimeType,
        file_size: e.fileSize,
        thumbnails: null === (t = e.thumbnails) || void 0 === t ? void 0 : t.map(function (e) {
          return {
            url: e.url,
            width: e.width,
            height: e.height,
            real_width: e.realWidth,
            real_height: e.realHeight
          };
        }),
        require_auth: e._requireAuth
      }));
    }, Object.defineProperty(n.prototype, "url", {
      get: function get() {
        var e = q.of(this._iid).sessionManager;
        return this._requireAuth ? "".concat(this.plainUrl, "?auth=").concat(e.ekey) : this.plainUrl;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(o),
  Te = function (t) {
    function n(e, n) {
      var a,
        i,
        u,
        o,
        d,
        c = this;
      if ((c = t.call(this, e, n) || this).messageParams = null, c.fileInfoList = [], c.messageSurvivalSeconds = -1, c.messageType = _.FILE, c.fileInfoList = null !== (i = null === (a = n.files) || void 0 === a ? void 0 : a.map(function (t) {
        return new Me(e, t);
      })) && void 0 !== i ? i : [], c.messageSurvivalSeconds = null !== (u = n.message_survival_seconds) && void 0 !== u ? u : -1, n.parent_message_info) {
        var h = n.parent_message_info;
        c.parentMessage = Ae(e, s(r(l(l({}, h), {
          created_at: h.ts,
          message_id: c.parentMessageId,
          channel_url: c.channelUrl,
          channel_type: c.channelType,
          file: h.file,
          url: null === (o = h.file) || void 0 === o ? void 0 : o.url,
          require_auth: null === (d = h.file) || void 0 === d ? void 0 : d.require_auth
        }))));
      }
      return c;
    }
    return e(n, t), n.prototype.getThreadedMessagesByTimestamp = function (e, t) {
      return b(this, void 0, void 0, function () {
        var n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return n = l(l({}, ge), t), E(this.messageId > 0 && c("number", e) && ye(n)).throw(w.invalidParameters), [4, Ke.of(this._iid).getThreadedMessagesByTimestamp(this, e, n)];
            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, n.payloadify = function (e) {
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        files: e.fileInfoList && e.fileInfoList && Array.isArray(e.fileInfoList) ? e.fileInfoList.map(function (e) {
          return Me.payloadify(e);
        }) : null,
        message_survival_seconds: e.messageSurvivalSeconds,
        parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null
      })));
    }, n._isMultipleFilesMessagePayload = function (e) {
      var t = e.files;
      return Array.isArray(t) && t.length >= 2;
    }, n._isMultipleFilesMessageSerializedData = function (e) {
      var t = e.fileInfoList;
      return Array.isArray(t);
    }, n;
  }(me),
  Se = function Se(e) {
    switch (e.messageType) {
      case _.USER:
        return Ie.payloadify(e);
      case _.FILE:
        return e.fileInfoList ? Te.payloadify(e) : be.payloadify(e);
      case _.ADMIN:
        return _e.payloadify(e);
      default:
        throw w.unknown;
    }
  },
  Ae = function Ae(e, t) {
    switch (t.type) {
      case "MESG":
        return new Ie(e, t);
      case "FILE":
        return Te._isMultipleFilesMessagePayload(t) ? new Te(e, t) : new be(e, t);
      case "ADMM":
      case "BRDM":
        return new _e(e, t);
    }
    throw w.unknown;
  },
  be = function (t) {
    function n(e, n) {
      var a,
        i,
        u,
        o,
        d,
        c,
        h,
        p,
        m,
        f,
        g,
        y,
        v,
        I,
        M = this;
      (M = t.call(this, e, n) || this).messageParams = null, M.plainUrl = "", M.requireAuth = !1, M.thumbnails = [], M.messageSurvivalSeconds = -1, M.messageType = _.FILE;
      var T = n.file;
      M.plainUrl = (null !== (i = null !== (a = null == T ? void 0 : T.url) && void 0 !== a ? a : n.url) && void 0 !== i ? i : "").split("?auth=")[0], M.name = null !== (o = null !== (u = null == T ? void 0 : T.name) && void 0 !== u ? u : n.name) && void 0 !== o ? o : "File", M.size = null !== (c = null !== (d = null == T ? void 0 : T.size) && void 0 !== d ? d : n.size) && void 0 !== c ? c : 0, M.data = null !== (p = null !== (h = null == T ? void 0 : T.data) && void 0 !== h ? h : n.custom) && void 0 !== p ? p : "", M.type = T ? null !== (m = T.type) && void 0 !== m ? m : "" : null !== (f = n.type) && void 0 !== f ? f : "";
      var S = q.of(M._iid).sessionManager;
      if (M.requireAuth = null !== (g = n.require_auth) && void 0 !== g && g, M.thumbnails = n.thumbnails ? n.thumbnails.map(function (e) {
        return new fe(l(l({}, e), {
          url: "".concat(e.url.split("?auth=")[0]).concat(M.requireAuth ? "?auth=".concat(S.ekey) : "")
        }));
      }) : [], M.messageSurvivalSeconds = null !== (y = n.message_survival_seconds) && void 0 !== y ? y : -1, n.parent_message_info) {
        var A = n.parent_message_info;
        M.parentMessage = Ae(e, s(r(l(l({}, A), {
          created_at: A.ts,
          message_id: M.parentMessageId,
          channel_url: M.channelUrl,
          channel_type: M.channelType,
          file: A.file,
          url: null === (v = A.file) || void 0 === v ? void 0 : v.url,
          require_auth: null === (I = A.file) || void 0 === I ? void 0 : I.require_auth
        }))));
      }
      return M;
    }
    return e(n, t), n.payloadify = function (e) {
      var n;
      return s(r(l(l({}, t.payloadify.call(this, e)), {
        url: e.plainUrl,
        require_auth: e.requireAuth,
        file: {
          name: e.name,
          size: e.size,
          type: e.type,
          data: e.data
        },
        thumbnails: null === (n = e.thumbnails) || void 0 === n ? void 0 : n.map(function (e) {
          return {
            url: e.url,
            width: e.width,
            height: e.height,
            real_width: e.realWidth,
            real_height: e.realHeight
          };
        }),
        message_survival_seconds: e.messageSurvivalSeconds,
        parent_message_info: e.parentMessage ? t._getParentMessageInfoPayload.call(this, e.parentMessage) : null
      })));
    }, Object.defineProperty(n.prototype, "url", {
      get: function get() {
        var e = q.of(this._iid).sessionManager;
        return this.requireAuth ? "".concat(this.plainUrl, "?auth=").concat(e.ekey) : this.plainUrl;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.getThreadedMessagesByTimestamp = function (e, t) {
      return b(this, void 0, void 0, function () {
        var n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return n = l(l({}, ge), t), E(this.messageId > 0 && c("number", e) && ye(n)).throw(w.invalidParameters), [4, Ke.of(this._iid).getThreadedMessagesByTimestamp(this, e, n)];
            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, n;
  }(me),
  Ue = function (t) {
    function n(e) {
      var n,
        a,
        i,
        l = [];
      return e.mentionType === M.USERS && (e.mentionedUserIds ? l = e.mentionedUserIds : e.mentionedUsers && (l = e.mentionedUsers.map(function (e) {
        return e.userId;
      }))), t.call(this, {
        code: "FILE",
        ackRequired: !0,
        payload: s(r({
          channel_url: e.channelUrl,
          files: e.files ? qe(e.files) : null,
          url: e.url,
          name: null !== (n = e.fileName) && void 0 !== n ? n : "",
          type: null !== (a = e.mimeType) && void 0 !== a ? a : "",
          size: null !== (i = e.fileSize) && void 0 !== i ? i : 0,
          custom: e.data,
          custom_type: e.customType,
          thumbnails: e.thumbnailSizes,
          require_auth: e.requireAuth,
          metaarray: e.metaArrays,
          mention_type: e.mentionType,
          mentioned_user_ids: l,
          push_option: e.pushNotificationDeliveryOption && e.pushNotificationDeliveryOption !== D.DEFAULT ? e.pushNotificationDeliveryOption : void 0,
          apple_critical_alert_options: e.appleCriticalAlertOptions ? de.payloadify(e.appleCriticalAlertOptions) : null,
          silent: e.silent,
          reply_to_channel: e.isReplyToChannel,
          parent_message_id: e.parentMessageId ? e.parentMessageId : null,
          req_id: e.reqId,
          pin_message: e.isPinnedMessage
        }))
      }) || this;
    }
    return e(n, t), n;
  }(N),
  Ee = function (n) {
    function a(e) {
      var a,
        i,
        l = this;
      l = n.call(this) || this;
      var u = [];
      return e.mentionType === M.USERS && (e.mentionedUserIds ? u = e.mentionedUserIds : e.mentionedUsers && (u = e.mentionedUsers.map(function (e) {
        return e.userId;
      }))), l.method = t.POST, l.path = "".concat(P(e.channelType), "/").concat(encodeURIComponent(e.channelUrl), "/messages"), l.params = s(r({
        message_type: _.FILE,
        user_id: e.userId,
        files: e.files ? qe(e.files) : null,
        url: e.fileUrl,
        mention_type: e.mentionType,
        mentioned_user_ids: u,
        file_name: e.fileName,
        file_size: e.fileSize,
        file_type: e.mimeType,
        data: e.data,
        custom_type: e.customType,
        thumbnails: null === (a = e.thumbnailSizes) || void 0 === a ? void 0 : a.map(function (e) {
          return fe.payloadify(e);
        }),
        require_auth: e.requireAuth,
        sorted_metaarray: null === (i = e.metaArrays) || void 0 === i ? void 0 : i.map(function (e) {
          return le.payloadify(e);
        }),
        push_option: e.pushNotificationDeliveryOption,
        parent_message_id: e.parentMessageId ? e.parentMessageId : null,
        apple_critical_alert_options: e.appleCriticalAlertOptions ? de.payloadify(e.appleCriticalAlertOptions) : null,
        reply_to_channel: e.isReplyToChannel,
        req_id: e.reqId,
        pin_message: e.isPinnedMessage
      })), l;
    }
    return e(a, n), a;
  }(a),
  we = function (t) {
    function n(e, n, s) {
      var a,
        i,
        r,
        l,
        u = this;
      (u = t.call(this, e, "FILE", s) || this).message = s.files && s.files.length >= 2 ? new Te(e, s) : new be(e, s);
      var o = q.of(e).sdkState;
      return u.isMentioned = C(u.message.mentionType, null !== (r = null !== (a = u.message.mentionedUserIds) && void 0 !== a ? a : null === (i = u.message.mentionedUsers) || void 0 === i ? void 0 : i.map(function (e) {
        return e.userId;
      })) && void 0 !== r ? r : [], o.userId), u.forceUpdateLastMessage = null !== (l = s.force_update_last_message) && void 0 !== l && l, u;
    }
    return e(n, t), n;
  }(R),
  Fe = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r,
        l = this;
      (l = t.call(this, e, n) || this).message = n.files && n.files.length >= 2 ? new Te(e, n) : new be(e, n);
      var u = q.of(e).sdkState;
      return l.isMentioned = C(l.message.mentionType, null !== (i = null !== (s = l.message.mentionedUserIds) && void 0 !== s ? s : null === (a = l.message.mentionedUsers) || void 0 === a ? void 0 : a.map(function (e) {
        return e.userId;
      })) && void 0 !== i ? i : [], u.userId), l.forceUpdateLastMessage = null !== (r = n.force_update_last_message) && void 0 !== r && r, l;
    }
    return e(n, t), n;
  }(i);
function qe(e) {
  return e.map(function (e) {
    var t, n;
    return s(r({
      url: e.fileUrl,
      file_name: e.fileName,
      file_type: e.mimeType,
      file_size: e.fileSize,
      thumbnails: null === (t = e.thumbnailSizes) || void 0 === t ? void 0 : t.map(function (e) {
        return fe.payloadify(e);
      }),
      require_auth: null === (n = e._uploadedMetaData) || void 0 === n ? void 0 : n.requireAuth
    }));
  });
}
var De;
!function (e) {
  e[e.PENDING = 0] = "PENDING", e[e.UPLOADING = 1] = "UPLOADING", e[e.UPLOADED = 2] = "UPLOADED", e[e.SENDING = 3] = "SENDING", e[e.FAILED = 4] = "FAILED";
}(De || (De = {}));
var Ne = function () {
  function e(e, t) {
    var n = t.sdkState,
      s = t.dispatcher,
      a = t.requestQueue,
      i = t.onlineDetector,
      r = t.cacheContext,
      l = this;
    this._queueMap = new Map(), this._iid = e, this._sdkState = n, this._requestQueue = a, this._cacheContext = r, this._dispatcher = s, this._dispatcher.on(function (e) {
      e instanceof L && (l._connectionState = e.stateType);
    }), this._onlineDetector = i;
  }
  return Object.defineProperty(e.prototype, "_shouldSendThroughWebSocket", {
    get: function get() {
      return this._connectionState === O.CONNECTED || this._connectionState === O.CONNECTING || this._connectionState === O.RECONNECTING;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._sendFileMessage = function (e, t) {
    return b(this, void 0, void 0, function () {
      var n, s, a;
      return U(this, function (i) {
        switch (i.label) {
          case 0:
            return n = this._createSendFileMessageRequestParams(e, t), this._shouldSendThroughWebSocket ? (s = new Ue(n), [4, this._requestQueue.send(s)]) : [3, 2];
          case 1:
            return a = i.sent(), [2, a.as(we).message];
          case 2:
            return s = new Ee(l(l({}, n), {
              userId: this._sdkState.userId
            })), [4, this._requestQueue.send(s)];
          case 3:
            return a = i.sent(), [2, a.as(Fe).message];
        }
      });
    });
  }, e.prototype._createSendFileMessageRequestParams = function (e, t) {
    var n = l(l({}, t.params), {
      channelUrl: e.url,
      channelType: e.channelType,
      reqId: t.requestId,
      url: ""
    });
    if (t.multipleFileUploadInfo) {
      var s = t.params;
      n.files = s.fileInfoList;
    } else {
      s = t.params;
      n.url = s.fileUrl, n.requireAuth = s.requireAuth;
    }
    return n;
  }, e.prototype._resolveMessageQueue = function (e) {
    var t;
    return b(this, void 0, void 0, function () {
      var n, s, a, i, r, l, u, o, d, c, h, p, m;
      return U(this, function (g) {
        switch (g.label) {
          case 0:
            if (!(n = this._queueMap.get(e.url))) return [3, 21];
            if (n.isResolving) return [3, 20];
            n.isResolving = !0, s = [], a = !0, g.label = 1;
          case 1:
            g.trys.push([1, 15, 16, 17]), i = f(n.messageQueue), r = i.next(), g.label = 2;
          case 2:
            if (r.done) return [3, 14];
            switch (l = r.value, l.state) {
              case De.PENDING:
              case De.UPLOADING:
                return [3, 3];
              case De.UPLOADED:
                return [3, 4];
              case De.FAILED:
                return [3, 12];
            }
            return [3, 13];
          case 3:
            return a = !1, s.push(l), [3, 13];
          case 4:
            if (!a) return [3, 10];
            g.label = 5;
          case 5:
            return g.trys.push([5, 8,, 9]), l.state = De.SENDING, [4, this._sendFileMessage(e, l)];
          case 6:
            return u = g.sent(), l.deferred.resolve(u), [4, z(100)];
          case 7:
            return g.sent(), [3, 9];
          case 8:
            return o = g.sent(), l.deferred.reject(o), [3, 9];
          case 9:
            return [3, 11];
          case 10:
            s.push(l), g.label = 11;
          case 11:
            return [3, 13];
          case 12:
            return d = null !== (t = l.error) && void 0 !== t ? t : w.unknown, l.deferred.reject(d.code === k.REQUEST_CANCELED ? w.fileUploadCanceled : d), [3, 13];
          case 13:
            return r = i.next(), [3, 2];
          case 14:
            return [3, 17];
          case 15:
            return c = g.sent(), p = {
              error: c
            }, [3, 17];
          case 16:
            try {
              r && !r.done && (m = i.return) && m.call(i);
            } finally {
              if (p) throw p.error;
            }
            return [7];
          case 17:
            return h = n.isResolveRequestPending, n.messageQueue = s, n.isResolving = !1, n.isResolveRequestPending = !1, h ? [4, this._resolveMessageQueue(e)] : [3, 19];
          case 18:
            g.sent(), g.label = 19;
          case 19:
            return [3, 21];
          case 20:
            n.isResolveRequestPending = !0, g.label = 21;
          case 21:
            return [2];
        }
      });
    });
  }, e.prototype._uploadNextPendingItem = function (e) {
    var t;
    return b(this, void 0, void 0, function () {
      var n, s, a, i, r, l, u, o, d;
      return U(this, function (c) {
        switch (c.label) {
          case 0:
            return (n = this._queueMap.get(e.url)) && (s = n.messageQueue.find(function (e) {
              return e.state === De.PENDING;
            })) ? s.multipleFileUploadInfo ? (a = s.multipleFileUploadInfo, i = a.uploadIndex, r = a.uploadCount, l = a.requestHandler, d = s.params, u = d.fileInfoList[i], !x(u.file) || (null === (t = u._uploadedMetaData) || void 0 === t ? void 0 : t.isUploaded) ? [3, 2] : [4, this._tryUploadNextItemAndUpdateItemState(e, n, s)]) : [3, 4] : [3, 9];
          case 1:
            return c.sent(), [3, 3];
          case 2:
            s.state = i < r - 1 ? De.PENDING : De.UPLOADED, c.label = 3;
          case 3:
            return o = i, null == l || l._triggerOnFileUploaded(s.requestId, o, u, s.error), s.multipleFileUploadInfo.uploadIndex++, [3, 7];
          case 4:
            return d = s.params, x(d.file) ? [4, this._tryUploadNextItemAndUpdateItemState(e, n, s)] : [3, 6];
          case 5:
            return c.sent(), [3, 7];
          case 6:
            d.thumbnailSizes = [], s.state = De.UPLOADED, c.label = 7;
          case 7:
            return this._uploadNextPendingItem(e), [4, this._resolveMessageQueue(e)];
          case 8:
            c.sent(), c.label = 9;
          case 9:
            return [2];
        }
      });
    });
  }, e.prototype._tryUploadNextItemAndUpdateItemState = function (e, t, n) {
    return b(this, void 0, void 0, function () {
      var s, a, i, r, l, u;
      return U(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, this._onlineDetector.isOnline()];
          case 1:
            if (s = o.sent(), !q.of(this._iid).sessionManager.currentUser && !s) return n.error = w.connectionRequired, n.state = De.FAILED, [2];
            if (!(t.uploadQueue.length < 6)) return [3, 9];
            n.state = De.UPLOADING, t.uploadQueue.push(n), o.label = 2;
          case 2:
            return o.trys.push([2, 7,, 8]), n.multipleFileUploadInfo ? (a = n.multipleFileUploadInfo, i = a.uploadIndex, r = a.uploadCount, l = n.params, [4, this._uploadNextFileForMultipleFilesItemAndUpdateParams(e, n, l)]) : [3, 4];
          case 3:
            return o.sent(), n.state = i < r - 1 ? De.PENDING : De.UPLOADED, [3, 6];
          case 4:
            return l = n.params, [4, this._uploadNextFileForSingleFileItemAndUpdateParams(e, n, l)];
          case 5:
            o.sent(), n.state = De.UPLOADED, o.label = 6;
          case 6:
            return [3, 8];
          case 7:
            return u = o.sent(), n.error = u.code === k.REQUEST_FAILED ? new w({
              code: k.NETWORK_ERROR,
              message: "Failed to upload a file."
            }) : u, n.state = De.FAILED, [3, 8];
          case 8:
            this._dequeueUploadItem(t, n), o.label = 9;
          case 9:
            return [2];
        }
      });
    });
  }, e.prototype._dequeueUploadItem = function (e, t) {
    var n = e.uploadQueue.findIndex(function (e) {
      return e.requestId === t.requestId;
    });
    n >= 0 && e.uploadQueue.splice(n, 1);
  }, e.prototype._uploadNextFileForSingleFileItemAndUpdateParams = function (e, t, n) {
    var s, a, i;
    return b(this, void 0, void 0, function () {
      var r, l, u, o, d, c, h, p, m, f;
      return U(this, function (g) {
        switch (g.label) {
          case 0:
            return r = new ee({
              file: n.file,
              channelUrl: e.url,
              thumbnailSizes: n.thumbnailSizes,
              requestId: t.requestId
            }), [4, this._requestQueue.send(r)];
          case 1:
            return l = g.sent(), u = l.as(te), o = u.url, d = u.fileSize, c = void 0 === d ? n.fileSize : d, h = u.thumbnailSizes, p = void 0 === h ? n.thumbnailSizes : h, m = u.requireAuth, f = void 0 !== m && m, n.fileName = null !== (s = n.fileName) && void 0 !== s ? s : n.file.name, n.mimeType = null !== (a = n.mimeType) && void 0 !== a ? a : n.file.type, n.fileSize = null !== (i = n.fileSize) && void 0 !== i ? i : n.file.size, n.fileUrl = o, n.fileSize = c, n.thumbnailSizes = p, n.requireAuth = f, [2];
        }
      });
    });
  }, e.prototype._uploadNextFileForMultipleFilesItemAndUpdateParams = function (e, t, n) {
    var s, a, i;
    return b(this, void 0, void 0, function () {
      var r, u, o, d, c, h, p, m, f, g, y, _;
      return U(this, function (v) {
        switch (v.label) {
          case 0:
            return r = t.multipleFileUploadInfo.uploadIndex, u = n.fileInfoList[r], o = new ee({
              file: u.file,
              channelUrl: e.url,
              thumbnailSizes: u.thumbnailSizes,
              requestId: t.requestId
            }), [4, this._requestQueue.send(o)];
          case 1:
            return d = v.sent(), c = d.as(te), h = c.url, p = c.fileSize, m = void 0 === p ? u.fileSize : p, f = c.thumbnailSizes, g = void 0 === f ? u.thumbnailSizes : f, y = c.requireAuth, _ = void 0 !== y && y, u.fileName = null !== (s = u.fileName) && void 0 !== s ? s : u.file.name, u.mimeType = null !== (a = u.mimeType) && void 0 !== a ? a : u.file.type, u.fileSize = null !== (i = u.fileSize) && void 0 !== i ? i : u.file.size, u.file = void 0, u.fileUrl = h, u.fileSize = m, u.thumbnailSizes = g, u._uploadedMetaData = l(l({}, u._uploadedMetaData), {
              requireAuth: _,
              isUploaded: !0
            }), [2];
        }
      });
    });
  }, e.prototype.request = function (e, t, n, s) {
    return b(this, void 0, void 0, function () {
      var a, i, r, l, u;
      return U(this, function (o) {
        return this._queueMap.has(e.url) || (a = {
          messageQueue: [],
          uploadQueue: [],
          isResolving: !1,
          isResolveRequestPending: !1
        }, this._queueMap.set(e.url, a)), i = this._queueMap.get(e.url), r = new Q(), l = {
          requestId: t,
          params: n,
          state: De.PENDING,
          deferred: r
        }, function (e) {
          return "fileInfoList" in e;
        }(n) && (u = {
          uploadIndex: 0,
          uploadCount: n.fileInfoList.length,
          requestHandler: s
        }, l.multipleFileUploadInfo = u), i.messageQueue.push(l), this._uploadNextPendingItem(e), [2, r.promise];
      });
    });
  }, e.prototype.cancel = function (e, t) {
    var n,
      s,
      a = this._queueMap.get(e.url);
    if (a) {
      var i = t ? [a.messageQueue.find(function (e) {
        return e.requestId === t;
      })] : p([], m(a.messageQueue), !1);
      try {
        for (var r = f(i), l = r.next(); !l.done; l = r.next()) {
          var u = l.value;
          if (u) switch (u.state) {
            case De.PENDING:
              u.state = De.FAILED, u.error = w.requestCanceled, this._resolveMessageQueue(e);
              break;
            case De.UPLOADING:
              this._requestQueue.cancel(u.requestId);
          }
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          l && !l.done && (s = r.return) && s.call(r);
        } finally {
          if (n) throw n.error;
        }
      }
    }
  }, e;
}();
var Pe,
  Ce = {
    prevResultSize: 0,
    nextResultSize: 0,
    isInclusive: !1,
    reverse: !1,
    messageTypeFilter: A.ALL,
    customTypesFilter: void 0,
    senderUserIdsFilter: void 0,
    replyType: G.NONE,
    includeReactions: !1,
    includeMetaArray: !1,
    includeParentMessageInfo: !1,
    includeThreadInfo: !1,
    showSubchannelMessagesOnly: !1
  },
  Re = function Re(e) {
    return c("number", e.prevResultSize) && c("number", e.nextResultSize) && c("boolean", e.isInclusive) && c("boolean", e.reverse) && c("string", e.messageTypeFilter) && h(A, e.messageTypeFilter) && d("string", e.customTypesFilter, !0) && d("string", e.senderUserIdsFilter, !0) && h(G, e.replyType) && c("boolean", e.includeMetaArray) && c("boolean", e.includeReactions) && c("boolean", e.includeParentMessageInfo) && c("boolean", e.includeThreadInfo) && c("boolean", e.showSubchannelMessagesOnly);
  },
  Le = {
    replyType: G.NONE,
    includeReactions: !1,
    includeThreadInfo: !1,
    includeMetaArray: !1,
    includeParentMessageInfo: !1
  },
  Oe = function Oe(e) {
    return h(G, e.replyType) && c("boolean", e.includeReactions) && c("boolean", e.includeMetaArray) && c("boolean", e.includeParentMessageInfo) && c("boolean", e.includeThreadInfo);
  },
  ke = function (n) {
    function s(e) {
      var s = e.channelType,
        a = e.channelUrl,
        i = e.messageId,
        r = e.includeMetaArray,
        l = e.includeReactions,
        u = e.includeThreadInfo,
        o = e.includeParentMessageInfo,
        d = n.call(this) || this;
      return d.method = t.GET, d.path = "".concat(P(s), "/").concat(encodeURIComponent(a), "/messages/").concat(encodeURIComponent(i)), d.params = {
        is_sdk: !0,
        with_sorted_meta_array: r,
        include_reactions: l,
        include_thread_info: u,
        include_parent_message_info: o,
        include_poll_details: !0
      }, d;
    }
    return e(s, n), s;
  }(a),
  ze = function (t) {
    function n(e, n) {
      var s = t.call(this, e, n) || this;
      return s.message = n ? Ae(e, l({}, n)) : null, s;
    }
    return e(n, t), n;
  }(i),
  xe = function (n) {
    function a(e) {
      var a = e.channelType,
        i = e.channelUrl,
        l = e.timestamp,
        u = e.token,
        o = e.prevResultSize,
        d = e.nextResultSize,
        c = e.isInclusive,
        h = e.reverse,
        p = e.messageTypeFilter,
        m = e.customTypesFilter,
        f = e.senderUserIdsFilter,
        g = e.replyType,
        y = e.includeMetaArray,
        _ = e.includeReactions,
        v = e.parentMessageId,
        I = e.includeThreadInfo,
        M = e.includeParentMessageInfo,
        T = e.showSubchannelMessagesOnly,
        S = e.checkingContinuousMessages,
        A = n.call(this) || this;
      return A.method = t.GET, A.path = "".concat(P(a), "/").concat(encodeURIComponent(i), "/messages"), A.params = s(r({
        is_sdk: !0,
        prev_limit: o,
        next_limit: d,
        include: c,
        reverse: h,
        message_ts: l,
        message_id: u,
        message_type: null != p ? p : null,
        custom_types: m,
        sender_ids: f,
        include_reply_type: g,
        with_sorted_meta_array: y,
        include_reactions: _,
        parent_message_id: v,
        include_thread_info: I,
        include_parent_message_info: M,
        show_subchannel_message_only: T,
        include_poll_details: !0,
        checking_continuous_messages: S
      })), A;
    }
    return e(a, n), a;
  }(a),
  Qe = function (t) {
    function n(e, n) {
      var s = t.call(this, e, n) || this;
      return s.messages = n.messages.map(function (t) {
        return Ae(e, t);
      }), s;
    }
    return e(n, t), n;
  }(i),
  Ge = function (n) {
    function s(e) {
      var s = e.channelType,
        a = e.channelUrl,
        i = e.timestamp,
        r = e.token,
        l = e.replyType,
        u = e.includeMetaArray,
        o = e.includeReactions,
        d = e.includeThreadInfo,
        c = e.includeParentMessageInfo,
        h = n.call(this) || this;
      return h.method = t.GET, h.path = "".concat(P(s), "/").concat(encodeURIComponent(a), "/messages/changelogs"), h.params = {
        change_ts: i,
        token: r,
        with_sorted_meta_array: u,
        include_reactions: o,
        include_thread_info: d,
        include_reply_type: l,
        include_parent_message_info: c,
        include_poll_details: !0
      }, h;
    }
    return e(s, n), s;
  }(a),
  Be = function (t) {
    function n(e, n) {
      var s = t.call(this, e, n) || this;
      return s.updatedMessages = n.updated.map(function (t) {
        return Ae(e, t);
      }), s.deletedMessagesInfo = n.deleted.map(function (e) {
        return {
          messageId: e.message_id,
          deletedAt: e.deleted_at
        };
      }), s.hasMore = n.has_more, s.nextToken = n.next, s;
    }
    return e(n, t), n;
  }(i),
  je = function (n) {
    function s(e) {
      var s = e.channelUrl,
        a = e.scheduledMessageId,
        i = n.call(this) || this;
      return i.method = t.GET, i.path = "".concat(B, "/").concat(encodeURIComponent(s), "/scheduled_messages/").concat(encodeURIComponent(a)), i.params = {}, i;
    }
    return e(s, n), s;
  }(a),
  He = function (t) {
    function n(e, n) {
      var s = t.call(this, e, n) || this;
      return s.message = n ? Ae(e, l({}, n)) : null, s;
    }
    return e(n, t), n;
  }(i),
  We = {},
  Ke = function () {
    function e(e, t) {
      var n = t.sdkState,
        s = t.dispatcher,
        a = t.requestQueue,
        i = t.onlineDetector,
        r = t.cacheContext;
      this._iid = e, this._sdkState = n, this._requestQueue = a, this._dispatcher = s, this._cacheContext = r, this.fileMessageQueue = new Ne(e, {
        sdkState: n,
        dispatcher: s,
        requestQueue: a,
        onlineDetector: i,
        cacheContext: r
      }), We[e] = this;
    }
    return e.of = function (e) {
      return We[e];
    }, e.prototype.buildMessageFromSerializedData = function (e) {
      var t = j(e);
      switch (t.messageType) {
        case _.USER:
          return new Ie(this._iid, Ie.payloadify(t));
        case _.FILE:
          return Te._isMultipleFilesMessageSerializedData(t) ? new Te(this._iid, Te.payloadify(t)) : new be(this._iid, be.payloadify(t));
        case _.ADMIN:
          return new _e(this._iid, _e.payloadify(t));
      }
      throw w.invalidParameters;
    }, e.prototype.buildUserMessageCreateParamsFromSerializedData = function (e, t) {
      return s(r({
        data: t.data,
        customType: t.customType,
        mentionType: t.mentionType,
        mentionedUserIds: t.mentionedUserIds,
        mentionedUsers: t.mentionedUsers,
        mentionedMessageTemplate: t.mentionedMessageTemplate,
        metaArrays: t.metaArrays,
        parentMessageId: t.parentMessageId,
        isReplyToChannel: e.isReplyToChannel,
        pushNotificationDeliveryOption: e.pushNotificationDeliveryOption,
        appleCriticalAlertOptions: t.appleCriticalAlertOptions,
        reqId: t.reqId,
        message: t.message,
        translationTargetLanguages: Object.keys(t.translations),
        pollId: e.pollId
      }));
    }, e.prototype.buildFileMessageCreateParamsFromSerializedData = function (e, t) {
      var n;
      return s(r({
        data: t.data,
        customType: t.customType,
        mentionType: t.mentionType,
        mentionedUserIds: t.mentionedUserIds,
        mentionedUsers: t.mentionedUsers,
        mentionedMessageTemplate: t.mentionedMessageTemplate,
        metaArrays: t.metaArrays,
        parentMessageId: t.parentMessageId,
        isReplyToChannel: e.isReplyToChannel,
        pushNotificationDeliveryOption: e.pushNotificationDeliveryOption,
        appleCriticalAlertOptions: t.appleCriticalAlertOptions,
        reqId: t.reqId,
        file: e.file,
        fileKey: e.fileKey,
        fileUrl: t.plainUrl,
        fileName: t.name,
        fileSize: t.size,
        mimeType: t.type,
        thumbnailSizes: null === (n = t.thumbnails) || void 0 === n ? void 0 : n.map(function (e) {
          return {
            maxWidth: e.width,
            maxHeight: e.height
          };
        }),
        fileType: e.fileType,
        requireAuth: t.requireAuth
      }));
    }, e.prototype.buildMultipleFilesMessageCreateParamsFromSerializedData = function (e, t) {
      return s({
        data: t.data,
        customType: t.customType,
        mentionType: t.mentionType,
        mentionedUserIds: t.mentionedUserIds,
        mentionedUsers: t.mentionedUsers,
        mentionedMessageTemplate: t.mentionedMessageTemplate,
        metaArrays: t.metaArrays,
        parentMessageId: t.parentMessageId,
        isReplyToChannel: e.isReplyToChannel,
        pushNotificationDeliveryOption: e.pushNotificationDeliveryOption,
        appleCriticalAlertOptions: t.appleCriticalAlertOptions,
        reqId: t.reqId,
        fileInfoList: e.fileInfoList
      });
    }, e.prototype.buildScheduledUserMessageCreateParamsFromSerializedData = function (e, t) {
      return l(l({}, this.buildUserMessageCreateParamsFromSerializedData(e, t)), {
        scheduledAt: e.scheduledAt
      });
    }, e.prototype.buildScheduledFileMessageCreateParamsFromSerializedData = function (e, t) {
      return l(l({}, this.buildFileMessageCreateParamsFromSerializedData(e, t)), {
        scheduledAt: e.scheduledAt
      });
    }, e.prototype.buildSenderFromSerializedData = function (e) {
      var t = j(e);
      return new ce(this._iid, ce.payloadify(t));
    }, e.prototype.getMessage = function (e) {
      return b(this, void 0, void 0, function () {
        var t, n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return t = new ke(e), [4, this._requestQueue.send(t)];
            case 1:
              return n = s.sent(), [2, n.as(ze).message];
          }
        });
      });
    }, e.prototype.getScheduledMessage = function (e) {
      return b(this, void 0, void 0, function () {
        var t, n;
        return U(this, function (s) {
          switch (s.label) {
            case 0:
              return t = new je(e), [4, this._requestQueue.send(t)];
            case 1:
              return n = s.sent(), [2, n.as(He).message];
          }
        });
      });
    }, e.prototype.getMessagesByMessageId = function (e, t, n, s, a) {
      return void 0 === a && (a = H.REQUEST_MESSAGE), b(this, void 0, void 0, function () {
        var i, r, u;
        return U(this, function (o) {
          switch (o.label) {
            case 0:
              return i = new xe(l(l({
                channelType: t,
                channelUrl: e,
                token: String(n)
              }, Ce), s)), [4, this._requestQueue.send(i)];
            case 1:
              return r = o.sent(), u = r.as(Qe).messages, this._dispatcher.dispatch(new W({
                messages: u,
                source: a
              })), [2, u];
          }
        });
      });
    }, e.prototype.getMessagesByTimestamp = function (e, t, n, s, a) {
      return void 0 === a && (a = H.REQUEST_MESSAGE), b(this, void 0, void 0, function () {
        var i, r, u;
        return U(this, function (o) {
          switch (o.label) {
            case 0:
              return i = new xe(l(l({
                channelType: t,
                channelUrl: e,
                timestamp: n
              }, Ce), s)), [4, this._requestQueue.send(i)];
            case 1:
              return r = o.sent(), u = r.as(Qe).messages, this._dispatcher.dispatch(new W({
                messages: u,
                source: a
              })), [2, u];
          }
        });
      });
    }, e.prototype._getMessagesByTimestampForCollection = function (e, t, n, s, a, i) {
      return void 0 === a && (a = H.REQUEST_MESSAGE), b(this, void 0, void 0, function () {
        var r, u, o, d;
        return U(this, function (c) {
          switch (c.label) {
            case 0:
              return r = new xe(l(l(l({
                channelType: t,
                channelUrl: e,
                timestamp: n
              }, Ce), s), {
                checkingContinuousMessages: i
              })), [4, this._requestQueue.send(r)];
            case 1:
              return u = c.sent(), o = u.payload, d = u.as(Qe).messages, this._dispatcher.dispatch(new W({
                messages: d,
                source: a
              })), [2, {
                messages: d,
                isContinuousMessages: o
              }];
          }
        });
      });
    }, e.prototype.getThreadedMessagesByTimestamp = function (e, t, n, s) {
      return void 0 === s && (s = H.REQUEST_THREADED_MESSAGE), b(this, void 0, void 0, function () {
        var a, i, r, u;
        return U(this, function (o) {
          switch (o.label) {
            case 0:
              return a = new xe(l(l(l({
                channelUrl: e.channelUrl,
                channelType: e.channelType,
                timestamp: t
              }, ge), n), {
                replyType: G.ALL,
                parentMessageId: e.messageId,
                includeThreadInfo: !0
              })), [4, this._requestQueue.send(a)];
            case 1:
              return i = o.sent(), r = i.as(Qe).messages, (u = r.slice(1)).forEach(function (t) {
                t.parentMessage = e;
              }), this._dispatcher.dispatch(new W({
                messages: u,
                source: s
              })), [2, {
                parentMessage: r[0],
                threadedMessages: u
              }];
          }
        });
      });
    }, e.prototype.getMessageChangelogs = function (e, t, n, a, i) {
      return void 0 === i && (i = H.REQUEST_MESSAGE_CHANGELOGS), b(this, void 0, void 0, function () {
        var u, o, d, c, h, p, m, f;
        return U(this, function (g) {
          switch (g.label) {
            case 0:
              return u = new Ge(s(r(l(l({
                channelType: t,
                channelUrl: e,
                timestamp: "number" == typeof n ? n : null,
                token: "string" == typeof n ? n : null
              }, Le), a)))), [4, this._requestQueue.send(u)];
            case 1:
              return o = g.sent(), d = o.as(Be), c = d.updatedMessages, h = d.deletedMessagesInfo, p = d.hasMore, m = d.nextToken, f = h.map(function (e) {
                return e.messageId;
              }), c.length > 0 && this._dispatcher.dispatch(new W({
                messages: c,
                source: i
              })), f.length > 0 && this._dispatcher.dispatch(new K({
                messageIds: f,
                source: i
              })), [2, {
                updatedMessages: c,
                deletedMessageIds: f,
                hasMore: p,
                token: m
              }];
          }
        });
      });
    }, e;
  }(),
  Ve = function () {
    function e() {
      this._onPending = V, this._onFailed = V, this._onSucceeded = V;
    }
    return e.prototype._trigger = function (e, t) {
      switch (null == t ? void 0 : t.sendingStatus) {
        case T.PENDING:
          0 === t.errorCode && this._onPending(t);
          break;
        case T.FAILED:
        case T.CANCELED:
          this._onFailed(e, t.scheduledInfo ? null : t);
          break;
        case T.SCHEDULED:
        case T.SUCCEEDED:
          this._onSucceeded(t);
      }
    }, e.prototype.onPending = function (e) {
      return this._onPending = e, this;
    }, e.prototype.onFailed = function (e) {
      return this._onFailed = e, this;
    }, e.prototype.onSucceeded = function (e) {
      return this._onSucceeded = e, this;
    }, e;
  }(),
  Xe = function (t) {
    function n(e, n) {
      var s = t.call(this, e) || this;
      s.targetMessageId = 0;
      var a = n.thread_info,
        i = n.parent_message_id,
        r = n.channel_url,
        l = n.channel_type;
      return a && c("object", a) && c("number", i) && c("string", r) && c("string", l) && (s.threadInfo = new ne(e, a), s.targetMessageId = i, s.channelUrl = r, s.channelType = l), s;
    }
    return e(n, t), n;
  }(o),
  $e = {
    channelUrl: "",
    channelType: I.BASE,
    messageId: 0,
    includeReactions: !1,
    includeMetaArray: !1,
    includeParentMessageInfo: !1,
    includeThreadInfo: !1
  },
  Je = function (n) {
    function s(e) {
      var s = e.channelCustomType,
        a = e.keyword,
        i = e.limit,
        r = e.reverse,
        l = e.exactMatch,
        u = e.channelUrl,
        o = e.order,
        d = e.messageTimestampFrom,
        c = e.messageTimestampTo,
        h = e.advancedQuery,
        p = e.targetFields,
        m = e.nextToken,
        f = n.call(this) || this;
      return f.method = t.GET, f.path = "".concat(X, "/messages"), f.params = {
        custom_type: s,
        query: a,
        limit: i,
        reverse: r,
        exact_match: l,
        channel_url: u,
        message_ts_from: d,
        message_ts_to: c,
        sort_field: o,
        advanced_query: h,
        target_fields: p,
        after: m
      }, f;
    }
    return e(s, n), s;
  }(a),
  Ye = function (t) {
    function n(e, n) {
      var s = t.call(this, e, n) || this;
      return s.messages = n.results.map(function (t) {
        return Ae(e, t);
      }), s.hasNext = n.has_next, s.nextToken = n.end_cursor, s.totalCount = n.total_count, s;
    }
    return e(n, t), n;
  }(i);
!function (e) {
  e.SCORE = "score", e.TIMESTAMP = "ts";
}(Pe || (Pe = {}));
var Ze = function (t) {
    function n(e, n) {
      var s,
        a,
        i,
        r,
        l,
        u,
        o,
        d,
        c,
        h = this;
      return (h = t.call(this, e, n) || this).keyword = "", h.reverse = !1, h.exactMatch = !1, h.channelUrl = "", h.channelCustomType = "", h.messageTimestampFrom = null, h.messageTimestampTo = null, h.order = Pe.SCORE, h.advancedQuery = !1, h.targetFields = null, h._nextToken = "", h.totalCount = -1, h.keyword = n.keyword, h.reverse = null !== (s = n.reverse) && void 0 !== s && s, h.exactMatch = null !== (a = n.exactMatch) && void 0 !== a && a, h.channelUrl = null !== (i = n.channelUrl) && void 0 !== i ? i : "", h.channelCustomType = null !== (r = n.channelCustomType) && void 0 !== r ? r : "", h.messageTimestampFrom = null !== (l = n.messageTimestampFrom) && void 0 !== l ? l : null, h.messageTimestampTo = null !== (u = n.messageTimestampTo) && void 0 !== u ? u : null, h.order = null !== (o = n.order) && void 0 !== o ? o : Pe.SCORE, h.advancedQuery = null !== (d = n.advancedQuery) && void 0 !== d && d, h.targetFields = null !== (c = n.targetFields) && void 0 !== c ? c : null, h;
    }
    return e(n, t), n.prototype._validate = function () {
      return t.prototype._validate.call(this) && c("string", this.keyword) && this.keyword.length > 0 && c("boolean", this.reverse) && c("boolean", this.exactMatch) && c("string", this.channelUrl) && c("string", this.channelCustomType) && (c("number", this.messageTimestampFrom) || null === this.messageTimestampFrom) && (c("number", this.messageTimestampTo) || null === this.messageTimestampTo) && h(Pe, this.order) && c("boolean", this.advancedQuery) && d("string", this.targetFields, !0);
    }, n.prototype.next = function () {
      return b(this, void 0, void 0, function () {
        var e, t, n, s, a, i, u, o;
        return U(this, function (d) {
          switch (d.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, e = q.of(this._iid).requestQueue, t = new Je(r(l(l({}, this), {
                nextToken: this._nextToken ? this._nextToken : null
              }))), [4, e.send(t)]) : [3, 2] : [3, 5];
            case 1:
              return n = d.sent(), s = n.as(Ye), a = s.messages, i = s.hasNext, u = s.nextToken, o = s.totalCount, this._nextToken = u, this._hasNext = i, this._isLoading = !1, this.totalCount = o, [2, a];
            case 2:
              return [2, []];
            case 3:
              throw w.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw w.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, n;
  }($),
  et = function (t) {
    function n(e, n, s, a) {
      var i,
        r,
        l,
        u,
        o,
        d,
        c,
        h,
        p,
        m,
        f = this;
      return (f = t.call(this, e, n, s, a) || this).reverse = !1, f.messageTypeFilter = A.ALL, f.customTypesFilter = null, f.senderUserIdsFilter = null, f.replyType = G.NONE, f.includeMetaArray = !1, f.includeReactions = !1, f.includeParentMessageInfo = !1, f.includeThreadInfo = !1, f.showSubchannelMessagesOnly = !1, f._edge = Number.MAX_SAFE_INTEGER, f.reverse = null !== (i = a.reverse) && void 0 !== i && i, f.messageTypeFilter = null !== (r = a.messageTypeFilter) && void 0 !== r ? r : A.ALL, f.customTypesFilter = null !== (l = a.customTypesFilter) && void 0 !== l ? l : null, f.senderUserIdsFilter = null !== (u = a.senderUserIdsFilter) && void 0 !== u ? u : null, f.replyType = null !== (o = a.replyType) && void 0 !== o ? o : G.NONE, f.includeMetaArray = null !== (d = a.includeMetaArray) && void 0 !== d && d, f.includeReactions = null !== (c = a.includeReactions) && void 0 !== c && c, f.includeParentMessageInfo = null !== (h = a.includeParentMessageInfo) && void 0 !== h && h, f.includeThreadInfo = null !== (p = a.includeThreadInfo) && void 0 !== p && p, f.showSubchannelMessagesOnly = null !== (m = a.showSubchannelMessagesOnly) && void 0 !== m && m, f;
    }
    return e(n, t), n.prototype._validate = function () {
      return t.prototype._validate.call(this) && c("boolean", this.reverse) && h(A, this.messageTypeFilter) && h(G, this.replyType) && d("string", this.customTypesFilter, !0) && d("string", this.senderUserIdsFilter, !0) && c("boolean", this.includeMetaArray) && c("boolean", this.includeReactions) && c("boolean", this.includeParentMessageInfo) && c("boolean", this.includeThreadInfo) && c("boolean", this.showSubchannelMessagesOnly);
    }, n.prototype.load = function () {
      return b(this, void 0, void 0, function () {
        var e;
        return U(this, function (t) {
          switch (t.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, [4, Ke.of(this._iid).getMessagesByTimestamp(this.channelUrl, this.channelType, this._edge, r({
                prevResultSize: this.limit,
                nextResultSize: 0,
                isInclusive: !1,
                reverse: this.reverse,
                messageTypeFilter: this.messageTypeFilter,
                customTypesFilter: this.customTypesFilter,
                replyType: this.replyType,
                senderUserIdsFilter: this.senderUserIdsFilter,
                includeReactions: this.includeReactions,
                includeMetaArray: this.includeMetaArray,
                includeParentMessageInfo: this.includeParentMessageInfo,
                includeThreadInfo: this.includeThreadInfo,
                showSubchannelMessagesOnly: this.showSubchannelMessagesOnly
              }))]) : [3, 2] : [3, 5];
            case 1:
              return e = t.sent(), this._edge = Math.min.apply(Math, p([Number.MAX_SAFE_INTEGER], m(e.map(function (e) {
                return e.createdAt;
              })), !1)), this._hasNext = e.length >= this.limit, this._isLoading = !1, [2, e];
            case 2:
              return [2, []];
            case 3:
              throw w.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw w.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, n;
  }(J),
  tt = {
    channelUrl: "",
    scheduledMessageId: 0
  },
  nt = function (t) {
    function n() {
      var e = null !== t && t.apply(this, arguments) || this;
      return e._onFileUploaded = V, e;
    }
    return e(n, t), n.prototype._triggerOnFileUploaded = function (e, t, n, s) {
      this._onFileUploaded(e, t, n, s);
    }, n.prototype.onFileUploaded = function (e) {
      return this._onFileUploaded = e, this;
    }, n.prototype.onPending = function (e) {
      return t.prototype.onPending.call(this, e), this;
    }, n.prototype.onFailed = function (e) {
      return t.prototype.onFailed.call(this, e), this;
    }, n.prototype.onSucceeded = function (e) {
      return t.prototype.onSucceeded.call(this, e), this;
    }, n;
  }(Ve),
  st = function (t) {
    function n() {
      var e = null !== t && t.apply(this, arguments) || this;
      return e.name = "message", e;
    }
    return e(n, t), n.prototype.init = function (e, n) {
      var s = n.sdkState,
        a = n.dispatcher,
        i = n.sessionManager,
        r = n.requestQueue,
        l = n.logger,
        u = n.onlineDetector,
        o = n.cacheContext;
      t.prototype.init.call(this, e, {
        sdkState: s,
        dispatcher: a,
        sessionManager: i,
        requestQueue: r,
        logger: l,
        onlineDetector: u,
        cacheContext: o
      }), this._manager = new Ke(e, {
        sdkState: s,
        dispatcher: a,
        requestQueue: r,
        onlineDetector: u,
        cacheContext: o
      });
    }, n.prototype.buildMessageFromSerializedData = function (e) {
      return this._manager.buildMessageFromSerializedData(e);
    }, n.prototype.buildSenderFromSerializedData = function (e) {
      return this._manager.buildSenderFromSerializedData(e);
    }, n.prototype.getMessage = function (e) {
      return b(this, void 0, void 0, function () {
        var t;
        return U(this, function (n) {
          return t = l(l({}, $e), e), E(function (e) {
            return c("string", e.channelUrl) && h(I, e.channelType) && c("number", e.messageId) && c("boolean", e.includeReactions, !0) && c("boolean", e.includeMetaArray, !0) && c("boolean", e.includeParentMessageInfo, !0) && c("boolean", e.includeThreadInfo, !0);
          }(t)).throw(w.invalidParameters), [2, this._manager.getMessage(t)];
        });
      });
    }, n.prototype.getScheduledMessage = function (e) {
      return b(this, void 0, void 0, function () {
        var t;
        return U(this, function (n) {
          return t = l(l({}, tt), e), E(function (e) {
            return c("string", e.channelUrl) && "" !== e.channelUrl && c("number", e.scheduledMessageId) && e.scheduledMessageId > 0;
          }(t)).throw(w.invalidParameters), [2, this._manager.getScheduledMessage(t)];
        });
      });
    }, n;
  }(Y);
export { de as A, pe as B, be as F, ae as I, st as M, ue as O, ve as P, ie as R, me as S, fe as T, Ie as U, Ze as a, Te as b, Ke as c, le as d, et as e, ce as f, nt as g, Ve as h, Ce as i, Le as j, Oe as k, se as l, we as m, Se as n, te as o, Ae as p, ee as q, _e as r, Xe as s, Pe as t, oe as u, Re as v, re as w, Z as x, ne as y, Me as z };